import logger from "./logger";

/** @type {WebSocket} */
let socket;

/**
 *
 * @param {string} mediaId
 * @param {string} stationId
 * @returns
 */
export function initWebSocket(mediaId, stationId) {
  if (!mediaId || !stationId) {
    logger.error("Can't init WebSocket: missing `mediaId` or `stationId`!");
    return;
  }

  if (socket) {
    return socket;
  }

  socket = new WebSocket(
    `${
      import.meta.env.VITE_EVENT_BROKER_URL
    }?media=${mediaId}&station=${stationId}&consumer=external`
  );

  socket.onopen = () => {
    logger.info("WebSocket is ready!");
  };
  socket.onmessage = (event) => {
    logger.debug("Message received from server: ", JSON.parse(event?.data));
  };
  socket.onerror = (event) => {
    logger.error("Unexpected WebSocket error", event);
    socket.close();
    throw new Error(`Unexpected WebSocket error: ${JSON.stringify(event)}`);
  };
  socket.onclose = () => {
    logger.debug("WebSocket connection closed.");
    socket = null;
  };

  return socket;
}
